export enum Pages{
    dashboard = 'Dashboard',
    planning = 'Planning',
    data = 'Données',
    members = 'Equipes',
    qualifications = 'Formations',
    weekly_needs = 'Besoins hebdomadaires',
    none = ''
}